<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import config from '../config'

  export default {
    name: 'App',
    data () {
      return {
        section: 'Head'
      }
    },
    methods: {
      logout () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push('/login')
      },
      notifyMe (id) {
        if (Notification.permission !== 'granted') {
          Notification.requestPermission()
        } else {
          var notification = new Notification('New Testimony', {
            icon: config.domain + '/static/img/wwow-logo-min.png',
            body: 'Alert ! A new testimony has been created'
          })

          notification.onclick = function () {
            window.open(config.domain + '/testimonies/' + id)
          }
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.$options.sockets.onmessage = (data) => this.notifyMe(data.data)
        if (!Notification) {
          console.log('Desktop notifications not available in your browser. Try Chromium.')
          return
        }

        if (Notification.permission !== 'granted') {
          Notification.requestPermission()
        }
      })
    }
  }
</script>


<style>
@font-face {
  font-family: 'Avenir Light';
  src: url('/fonts/Avenir_Light.ttf');
}

body {
  font-family: 'Avenir Light';
}
</style>



// WEBPACK FOOTER //
// App.vue?3e83087e